import { Glyph } from '../ui/Icon'
import { Reveal } from '../ui/Reveal'
import { SmartLink } from '../ui/SmartLink'
import './Business.css'

/** A short pointer from the home page to the full business page. */
export function BusinessTeaser() {
  return (
    <section>
      <div className="wrap">
        <Reveal className="teaser glass amber">
          <div className="min0">
            <div className="eyebrow">For businesses</div>
            <h2>Put your business <em className="s">on the map.</em></h2>
            <p>Venues, brands and apps can reach people at the moment they're deciding what to do tonight.</p>
          </div>
          <SmartLink className="btn gold" to="/advertise">Advertise on mauj <Glyph name="arrow" width={2} /></SmartLink>
        </Reveal>
      </div>
    </section>
  )
}
